// Module
var code = "<div class=\"ng-logout-container\"> <div *ngIf=\"showMessage\" class=\"jumbotron text-center logout-hero\"> <h3 class=\"logout-message\">{{ message }}</h3> </div> </div> ";
// Exports
export default code;